import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { Feather } from 'lucide-react';

export default function AuthCallback() {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          const response = await exchangeSession(sessionId);
          const userName = response.user?.name || response.name || 'Reader';
          toast.success(`Welcome, ${userName}!`);
          
          // Clear the hash and navigate
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/archive', { replace: true });
        } catch (error) {
          console.error('Auth callback error:', error);
          toast.error('Authentication failed. Please try again.');
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen bg-parchment flex items-center justify-center">
      <div className="text-center animate-fade-in">
        <Feather className="w-12 h-12 text-wine mx-auto mb-6 animate-pulse" />
        <p className="font-playfair text-2xl text-charcoal mb-2">Authenticating</p>
        <p className="font-lora text-charcoal-muted">Please wait while we prepare your letters...</p>
      </div>
    </div>
  );
}
